import { render } from "./Gateways.vue?vue&type=template&id=de438c0a&ts=true"
import script from "./Gateways.vue?vue&type=script&setup=true&lang=ts"
export * from "./Gateways.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/Gateways.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "de438c0a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('de438c0a', __exports__)) {
    api.reload('de438c0a', __exports__)
  }
  
  module.hot.accept("./Gateways.vue?vue&type=template&id=de438c0a&ts=true", () => {
    api.rerender('de438c0a', render)
  })

}


export default __exports__